// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3pFkr","title":"ClientReferral_title__1pEKU","itemText":"ClientReferral_itemText__1eOim"};